module.exports = __webpack_public_path__ + "assets/2dc29bc3ab8d9c69ebfa62ef08c6265c.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/Multiple_Stem_X.mp3
 ** module id = 498
 ** module chunks = 0
 **/